import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { DashboardLayout } from '../../Layout/DashboardLayout'
import BASEURL from '../../Config/global'
import axios from 'axios'
import { questionModal, successModal } from '../../Components/CustomModal'
import CustomLoader from '../../Components/CustomLoader'
import './style.css'
import { AddImageComponent } from '../CategoryManagement/ImageComponent'
import CustomInput from '../../Components/CustomInput'
import BackButton from '../../Components/BackButton'
import { PermissionsContext } from '../../Layout/PermissionContext'
import { patchRequest } from '../../Util/requests'

const EditPublishFeatureMix = () => {
    const { permissions } = useContext(PermissionsContext)
    const navigate = useNavigate()
    const { id } = useParams()
    
    const [formData, setFormData] = useState({})
    const [categoryModalConfig, setCategoryModalConfig] = useState({ error: false, msg: '', value: '', loader: false })
    const [categoryMixList, setCategoryMixList] = useState([])
    const [subCategoryMixList, setSubCategoryMixList] = useState([])
    const [loader, setLoader] = useState(false)
    const [soundImage, setSoundImage] = useState(null)
    const [initialLoader, setInitialLoader] = useState(true)

    useEffect(() => {
        if (id) {
            getMixConfigurationById(id)
            getAllMixCategories()
        }
    }, [id])

    const getMixConfigurationById = async (mixerId) => {
        try {
            setInitialLoader(true)
            const response = await axios.get(`${BASEURL}/api/sounds/set-mixer-category/?mixer_id=${mixerId}`)
            if (!response.data.error) {
                const data = response?.data?.data
                setFormData(data)
                if (data?.parent_category_id) {
                    getMixSubCategoriesById(data?.parent_category_id)
                }
                setInitialLoader(false)
            }
        } catch (error) {
            setCategoryModalConfig({ ...categoryModalConfig, error: true, msg: error.message, loader: false })
            setInitialLoader(false)
        }
    }

    const getAllMixCategories = async () => {
        try {
            const response = await axios.get(`${BASEURL}/api/sounds/mixFeatureCategories`)
            setCategoryMixList(response?.data?.data)
        } catch (error) {
            console.error(error)
        }
    }

    const getMixSubCategoriesById = async (categoryId) => {
        try {
            const response = await axios.get(`${BASEURL}/api/sounds/mixsubcategories/${categoryId}`)
            setSubCategoryMixList(response?.data?.data)
        } catch (error) {
            console.error(error)
        }
    }

    const handleUpdateAdd = () => {
        questionModal
            .fire({
                title: `Do you want to update this mix?`,
                confirmButtonText: "Yes",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    addCategoryAndSubCategory()
                }
            })
    }

    const addCategoryAndSubCategory = async () => {
        try {
            if (!formData?.title || formData?.title === "" || !formData?.description || formData?.description === "") {
                setCategoryModalConfig({ ...categoryModalConfig, error: true, msg: 'Please fill all fields' })
                return
            }
            if (!formData?.parent_category_id || formData?.parent_category_id === undefined || formData?.parent_category_id === "undefined") {
                setCategoryModalConfig({ ...categoryModalConfig, error: true, msg: 'Parent Category is required' })
                return
            }
            if (!formData?.banner || formData?.banner === undefined || formData?.banner === "undefined") {
                setCategoryModalConfig({ ...categoryModalConfig, error: true, msg: 'Banner is required' })
                return
            }
            if (formData?.parent_category_id || formData?.sub_category_id || formData?.is_featured) {
                setCategoryModalConfig({ ...categoryModalConfig, error: false })
                setLoader(true)
                let body = {
                    "mixer_id": formData?.id,
                    "parent_category_id": formData?.parent_category_id,
                    "sub_category_id": formData?.sub_category_id,
                    "is_featured": formData?.is_featured,
                    "banner": formData?.banner,
                    "title": formData?.title,
                    "description": formData?.description,
                    "child_content": formData?.child_content
                }
                const response = await patchRequest(`/api/sounds/set-mixer-category/`, body)
                setLoader(false)
                if (!response.data.error && response.data.status === 200) {
                    successModal.fire({
                        text: `Mix updated successfully`,
                        confirmButtonText: "Continue",
                    })
                    navigate('/publish-featured-mix')
                }
            } else {
                setCategoryModalConfig({ ...categoryModalConfig, error: true, msg: 'No Changes Exist!' })
            }
        } catch (error) {
            setLoader(false)
            setCategoryModalConfig({ ...categoryModalConfig, msg: error.message, error: true })
            console.log(error)
        }
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0]
        if (file === null || file === "undefined") {
            // setSoundImage(null);
            // setFormData({ ...formData, file_upload: null })
        } else {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                setFormData({ ...formData, banner: reader.result })
                setSoundImage(reader.result)
            }
        }
    }

    const handleRemoveImage = (event) => {
        event.stopPropagation()
        event.preventDefault()
        setFormData({ ...formData, banner: null })
        setSoundImage(null)
    }

    const handleChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value })
        setCategoryModalConfig({ ...categoryModalConfig, error: false })
    }

    if (initialLoader) {
        return (
            <DashboardLayout>
                <div className='container-fluid'>
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                        <CustomLoader />
                    </div>
                </div>
            </DashboardLayout>
        )
    }

    return (
        <>
            <DashboardLayout>
                <div className='container-fluid'>
                    <div className="row mb-3">
                        <div className="col-12">
                            <h2 className="mainTitle"> <BackButton />Add Category</h2>
                        </div>
                    </div>

                    <div className="row w-100">
                        <div className='col-12'>
                            <div className='row'>
                                <div className='col-4'>
                                    <CustomInput
                                        label="Title"
                                        labelClass="mainLabel "
                                        required
                                        type="text"
                                        name="title"
                                        value={formData?.title || ""}
                                        placeholder="Enter Title"
                                        inputClass="mainInput"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className='col-4'>
                                    <p className="mainLabel">Select Category*</p>
                                    <select
                                        name="parent_category_id"
                                        id="parent_category_id"
                                        className="mainInput w-100"
                                        style={{ marginTop: '1px' }}
                                        value={formData?.parent_category_id || ""}
                                        onChange={(event) => {
                                            const { name, value } = event.target
                                            setFormData({
                                                ...formData, [name]: Number(value)
                                            })
                                            getMixSubCategoriesById(Number(value))
                                        }}
                                    >
                                        <option value={null}> Select </option>
                                        {categoryMixList.length > 0 && categoryMixList.map((item, index) => (
                                            <option key={index} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className='col-4'>
                                    <p className="mainLabel">Select Sub Category</p>
                                    <select
                                        name="sub_category_id"
                                        id="sub_category_id"
                                        className="mainInput w-100"
                                        style={{ marginTop: '1px' }}
                                        value={formData?.sub_category_id || ""}
                                        onChange={(event) => {
                                            const { name, value } = event.target
                                            setFormData({
                                                ...formData, [name]: Number(value)
                                            })
                                        }}
                                    >
                                        <option value={null}> Select </option>
                                        {subCategoryMixList.length > 0 && subCategoryMixList.map((item, index) => (
                                            <option key={index} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-4 mt-3">
                            <AddImageComponent
                                title={`Image`}
                                inputClass="asset-upload w-100 h-100"
                                soundImage={formData?.banner || null}
                                handleImageChange={(event) => handleImageChange(event)}
                                handleRemoveImage={(event) => handleRemoveImage(event)}
                            />
                        </div>
                        <div className='col-8 mt-3'>
                            <div className='row'>
                                <div className="col-12">
                                    <p className="mainLabel">Description</p>
                                    <textarea
                                        label="Description"
                                        labelClass="mainLabel"
                                        required
                                        type="text"
                                        style={{ minHeight: '260px' }}
                                        name="description"
                                        className="mainInput"
                                        value={formData?.description || ""}
                                        placeholder="Enter Description"
                                        inputClass="mainInput"
                                        onChange={handleChange}
                                        resize="vertical"
                                    />
                                </div>
                                <div className="col-6 mb-2">
                                    <div className='mt-2'>
                                        <input
                                            type="checkbox"
                                            name="featured"
                                            id="featured"
                                            checked={formData.is_featured ? true : false}
                                            onChange={() => {
                                                setFormData({
                                                    ...formData, 'is_featured': !formData.is_featured,
                                                })
                                            }}
                                        />
                                        <label htmlFor="featured" className="mainLabel ms-1">
                                            Featured
                                        </label>
                                    </div>
                                </div>
                                <div className="col-6 mb-2">
                                    <div className='mt-2'>
                                        <input
                                            type="checkbox"
                                            name="child_content"
                                            id="child_content"
                                            checked={formData.child_content ? true : false}
                                            onChange={() => {
                                                setFormData({
                                                    ...formData, 'child_content': !formData.child_content
                                                })
                                            }}
                                        />
                                        <label htmlFor="child_content" className="mainLabel ms-1">
                                            underage restriction
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {categoryModalConfig?.error && <small className="text-danger mt-3">{categoryModalConfig.msg}</small>}
                    <div className="pt-5 d-flex gap-3 justify-content-center mb-3">
                        <button
                            type='button'
                            style={{ backgroundColor: '#ffffff1f' }}
                            className='px-5 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0'
                            onClick={handleUpdateAdd}
                        >
                            UPDATE
                        </button>
                    </div>
                </div>
            </DashboardLayout>

            {/* Loader */}
            {loader && <div className='featured-loader'><CustomLoader /></div>}
        </>
    )
}

export default EditPublishFeatureMix



